import { GspCommonField } from './GspCommonField';
import { CommonDetermination } from './Operation/CommonDetermination';
import { CustomizationInfo } from '../../common-model/src/CustomizationInfo';


/**
 * 节点元数据
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 节点元数据
 */
export class GspCommonDataType {

  /**
   * 唯一标志
   */
  ID: string;

  /**
   * 编号
   */
  Code: string;

  /**
   * 名称
   */
  Name: string;

  /**
   * 是否引用
   */
  IsRef: boolean;

  /**
   * 当前节点字段集合
   */
  ContainElements: GspCommonField[];

  /**
   * 联动计算_保存前
   */
  DtmBeforeSave: CommonDetermination[];
  /**
   * 联动计算_修改后
   */
  DtmAfterModify: CommonDetermination[];
  /**
   * 联动计算_新增后
   */
  DtmAfterCreate: CommonDetermination[];
  /**
   * 联动计算_保存后
   */
  DtmAfterSave: CommonDetermination[];

  /**
   * 标签
   */
  BeLabel: string[];

  /**
 * 维度信息
 */
  CustomizationInfo: CustomizationInfo;
}
